import { useDepartments } from "@root/hooks/useDepartments";
import React, { createContext, useContext, ReactNode } from "react";

const DepartmentContext = createContext<any>(undefined);

interface DepartmentContextProviderProps {
  children: ReactNode;
}

export const DepartmentContextProvider: React.FC<
  DepartmentContextProviderProps
> = ({ children }) => {
  const data = useDepartments();
  return (
    <DepartmentContext.Provider value={data}>
      {children}
    </DepartmentContext.Provider>
  );
};

export const useDepartmentContext = () => {
  const context = useContext(DepartmentContext);
  return context;
};
